module.exports = __webpack_public_path__ + "DCA Flyer.pdf";